// React
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// Constants
import { ROUTES_CONSTANTS } from "../../constants/routesConstants";

// Utils
import { getCookie } from "../../utils/CookiesUtil";

const PublicRoute = ({ children }) => {

  const accessToken = getCookie("accessToken");

  if (accessToken) {
    return <Navigate to={ROUTES_CONSTANTS.DASHBOARD} />;
  }

  return children ? children : <Outlet />;
};

export default PublicRoute;
